module.exports = __webpack_public_path__ + "HelveticaBold.0c746921942ec062d3b0.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-dinamica-cliente/src/app/@theme/fontes/Helvetica/HelveticaBold.woff
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaBold.woff
// module chunks = styles